export const omitKeys = (source = {}, ...keys) =>
  Object.fromEntries(Object.entries(source).filter(([sourceKey]) => !keys.includes(sourceKey)));
